module.exports = __webpack_public_path__ + "img/vegetable-fennel-190x100.8e8467f8.jpg";